export type Rectangle<T> = {
  readonly height: T
  readonly width: T
}
